module.exports = __webpack_public_path__ + "static/img/33.c85063e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/33.png
// module id = RWl3
// module chunks = 0